<template>
   <v-dialog
      v-model="dialog"
      width="350"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        class="mr-3"
          icon
          v-bind="attrs"
          v-on="on"
        >
         <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
      </template>

      <v-card>

        <v-card-text>
            <p class="pa-5"> This is your temporary keyword list</p>
            <div class="icon" id="icon">
                <div class="arrow" id="arrow"></div>
            </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            next
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
 name: 'DashboardCoreSettings',
 data: () => ({
     dialog: false,

 }),
 methods:{
     arrowanimate(){
        const icon = document.getElementById('icon');
        const arrow = document.getElementById('arrow');
        arrow.animate([
            {left: '0'},
            {left: '10px'},
            {left: '0'}
        ],{
            duration: 700,
            iterations: Infinity
        });
     }
 },
 created(){
    //  this.arrowanimate();
 }
}
</script>

<style scoped>
.v-dialog {
    position: absolute;
    top: 0;
    right: 0;
    margin-right: 80    px;
}
.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 80px;
  height: 60px;
  cursor: pointer;
}

.arrow {
  position: absolute;
  top: 25px;
  width: 90%;
  height: 10px;
  background-color: #fff;
  box-shadow: 0 3px 5px rgba(0, 0, 0, .2);
  animation: arrow 700ms linear infinite;
}

.arrow::after, .arrow::before {
  content: '';
  position: absolute;
  width: 60%;
  height: 10px;
  right: -8px;
  background-color: #fff;
}

.arrow::after {
  top: -12px;
  transform: rotate(45deg);
}

.arrow::before {
  top: 12px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, .2);
  transform: rotate(-45deg);
}
</style>